module.exports = __webpack_public_path__ + "static/img/dso_cokol.c2b5c52.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/urzadzenia/dso_cokol.svg
// module id = Q0kR
// module chunks = 1